import { FLOOR_IDS } from 'common/consts/floor-ids.const';
import { DataContext } from 'entries/common/widgets/context';
import { useContext } from 'react';

export const useIsFloorCalculator = () => {
  const data = useContext(DataContext);
  const calculatorId = data?.surfaces?.id || '';
  return FLOOR_IDS.includes(calculatorId);
};
